import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography, useTheme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface YearSelectorProps {
    selectedYear: string;
    yearOptions: string[];
    onYearChange: (event: SelectChangeEvent) => void;
}

const YearSelector: React.FC<YearSelectorProps> = ({ 
    selectedYear, 
    yearOptions, 
    onYearChange 
}) => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: { xs: '100%', sm: 'auto' } }}>
            <FormControl size="medium" sx={{ width: { xs: '100%', sm: 'auto' } }}>
                <Select 
                    value={selectedYear} 
                    onChange={onYearChange} 
                    sx={{
                        minWidth: { xs: '100%', sm: 100 },
                        width: { xs: '100%', sm: 'auto' },
                        borderRadius: 1,
                        backgroundColor: 'transparent !important',
                        '& .MuiSelect-select': {
                            py: 1,
                            px: 2,
                            fontWeight: 'bold',
                            fontSize: '1.1rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'transparent !important',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '2px',
                            borderColor: theme.palette.primary.main,
                            borderRadius: 1
                        },
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '2px',
                            borderColor: theme.palette.primary.main,
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderWidth: '2px',
                            borderColor: theme.palette.primary.main,
                        },
                        '& .MuiSelect-icon': {
                            right: 8,
                            top: 'calc(50% - 0.5em)',
                        },
                        fontWeight: 'bold'
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                '& .MuiMenuItem-root': {
                                    fontSize: '1.1rem',
                                    fontWeight: 'bold',
                                }
                            }
                        }
                    }}
                >
                    {yearOptions.map((year) => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: theme.palette.text.secondary, width: { xs: '100%', sm: 'auto' }, fontSize: '1.1rem' }}>
                {t('taxReports.dateRange', { year: selectedYear })}
            </Typography>
        </Box>
    );
};

export default YearSelector;
